import React from 'react';
import './SortBar.css';

/**
 * SortBar - Sort buttons: Best, Cheapest, Price, Duration, Stops
 * Matches SanoGrid design
 */
const SortBar = ({ totalResults, sortBy, onSortChange }) => {
  
  const sortOptions = [
    { id: 'best', label: 'Best' },
    { id: 'cheapest', label: 'Cheapest' },
    { id: 'price', label: 'Price' },
    { id: 'duration', label: 'Duration' },
    { id: 'stops', label: 'Stops' },
  ];

  return (
    <div className="sp-results-meta">
      <div className="sp-results-count">
        <strong>{totalResults}</strong> {totalResults === 1 ? 'flight' : 'flights'} found
      </div>

      <div className="sp-sort-bar">
        <span className="sp-sort-label">Sort:</span>
        {sortOptions.map(option => (
          <button
            key={option.id}
            className={`sp-sort-btn ${sortBy === option.id ? 'active' : ''}`}
            onClick={() => onSortChange(option.id)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SortBar;